import {
  START_GET_GROUP_LIST,
  SUCCESS_GET_GROUP_LIST,
  ERROR_GET_GROUP_LIST,
  START_CREATE_GROUP,
  SUCCESS_CREATE_GROUP,
  ERROR_CREATE_GROUP,
  START_UPDATE_GROUP,
  SUCCESS_UPDATE_GROUP,
  ERROR_UPDATE_GROUP,
  START_DELETE_GROUP,
  SUCCESS_DELETE_GROUP,
  ERROR_DELETE_GROUP,
  START_GET_PATIENT_FIELD_LIST,
  SUCCESS_GET_PATIENT_FIELD_LIST,
  ERROR_GET_PATIENT_FIELD_LIST,
  RESET_GROUP_STATE,
  START_GET_SINGLE_GROUP,
  SUCCESS_GET_SINGLE_GROUP,
  ERROR_GET_SINGLE_GROUP,
  START_UPDATE_ORDERDATE_GROUP,
  SUCCESS_UPDATE_ORDERDATE_GROUP,
  ERROR_UPDATE_ORDERDATE_GROUP,
} from "Actions/GroupAction";

const initialState = {
  groupList: {
    loading: true,
    data: {},
    error: {},
  },
  createGroupData: {
    loading: false,
    data: {},
    error: {},
  },
  updateGroupData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteGroupData: {
    loading: false,
    data: {},
    error: {},
  },
  singleGroup: {
    loading: false,
    data: {},
    error: {},
  },
  patientFieldList: {
    loading: false,
    data: {},
    error: {},
  },
  updateOrderDate: {
    loading: false,
    data: {},
    error: {},
  },
};

export const GroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_GROUP_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_GROUP_LIST: {
      let oldList = state?.groupList?.data;
      return {
        ...state,
        groupList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_GROUP_LIST: {
      let oldList = state?.groupList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        groupList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_GROUP_LIST: {
      return {
        ...state,
        groupList: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_CREATE_GROUP: {
      return {
        ...state,
        createGroupData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_GROUP: {
      let oldList = state?.groupList?.data;
      let tempData = [action?.payload?.data, ...oldList?.list];
      oldList.filterd_record = oldList?.filterd_record + 1;
      oldList.list = tempData;
      // oldList.list = oldList.list.sort(
      //   (a, b) => parseFloat(b.patient_count) - parseFloat(a.patient_count)
      // );
      return {
        ...state,
        createGroupData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_GROUP: {
      return {
        ...state,
        createGroupData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_GROUP: {
      return {
        ...state,
        updateGroupData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_GROUP: {
      let oldList = state?.groupList?.data;
      let tempData = oldList?.list?.map((item) => {
        if (item?.g_id == action?.id) {
          return action?.payload?.data;
        } else {
          return item;
        }
      });
      oldList.list = tempData;
      // oldList.list = tempData.sort(
      //   (a, b) => parseFloat(b.patient_count) - parseFloat(a.patient_count)
      // );
      return {
        ...state,
        updateGroupData: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_GROUP: {
      return {
        ...state,
        updateGroupData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_ORDERDATE_GROUP: {
      return {
        ...state,
        updateOrderDate: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_ORDERDATE_GROUP: {
      let oldList = state?.groupList?.data;
      let tempData = oldList?.list?.map((item) => {
        if (item?.g_id == action?.id) {
          return action?.payload?.data;
        } else {
          return item;
        }
      });
      oldList.list = tempData;
      // .sort(
      //   (a, b) => parseFloat(b.patient_count) - parseFloat(a.patient_count)
      // );
      return {
        ...state,
        updateOrderDate: {
          loading: false,
          data: oldList,
          error: {},
        },
        updateGroupData: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_ORDERDATE_GROUP: {
      return {
        ...state,
        updateOrderDate: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_GROUP: {
      return {
        ...state,
        deleteGroupData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_GROUP: {
      let oldList = state?.groupList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.g_id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteGroupData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_GROUP: {
      return {
        ...state,
        deleteGroupData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_GROUP: {
      let oldList = state?.singleGroup?.data;
      return {
        ...state,
        singleGroup: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SINGLE_GROUP: {
      let oldList = state?.singleGroup?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singleGroup: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SINGLE_GROUP: {
      return {
        ...state,
        singleGroup: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_GET_PATIENT_FIELD_LIST: {
      let oldList = state?.patientFieldList?.data;
      return {
        ...state,
        patientFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_PATIENT_FIELD_LIST: {
      let oldList = state?.patientFieldList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        patientFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_PATIENT_FIELD_LIST: {
      return {
        ...state,
        patientFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
